<template>
  <div class="mt-5 ml-5">
    <v-divider/>
    <div class="mt-10 title-content">Perguntas</div>
    <v-row dense>
      <v-col cols="12">
        <v-alert
          class="mt-5"
          type="info"
          outlined
          dismissible>
          Todas as perguntas são públicas.
        </v-alert>
      </v-col>
    </v-row>

    <px-oferta-duvidas-list ref="duvidasList"
                            is-fornecedor
                            :oferta="oferta"
                            :method-getter-fornecedor="ofertaService.getDuvidas"
                            :method-responder="ofertaService.responderDuvidas"/>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import OfertaService from '../oferta-service';

export default {
  props: {
    oferta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      grupoId: this.$route.params.idGrupo,
      comprador: null,
      pergunta: null,
      loading: false,
      ofertaService: OfertaService,
    };
  },
  validations: {
    pergunta: {
      required,
    },
  },
};
</script>
